export default function GetLocale() {
    return navigator.language || 'en-GB';
}
